import TopNav from "../../home/components/TopNav";
import IMHero from "./components/IMHero";
import IMFeatures from "./components/IMFeatures";
import IMMonitor from "./components/IMMonitor";
import IMEnterprise from "./components/IMEnterprise";
import IMSystemDemo from "./components/IMSystemDemo";
import IMCases from "./components/IMCases";
import IMContact from "./components/IMContact";

export default function InvestmentManagementPage() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Noto Sans SC', sans-serif" }}>
      <TopNav />
      <div className="pt-14">
        <IMHero />
        <IMFeatures />
        <IMMonitor />
        <IMEnterprise />
        <IMSystemDemo />
        <IMCases />
        <IMContact />
      </div>
    </div>
  );
}
